export default __webpack_public_path__ + "static/media/Vendor_Portal_Manual.c732c904.pdf";